import { render } from "./LargeAssetItem.vue?vue&type=template&id=5c711b98&scoped=true"
import script from "./LargeAssetItem.ts?vue&type=script&lang=js"
export * from "./LargeAssetItem.ts?vue&type=script&lang=js"

import "./LargeAssetItem.vue?vue&type=style&index=0&id=5c711b98&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c711b98"]])

export default __exports__